import React, { useState } from 'react';
import OrangeButton from '../buttons/orange-button';
import OrangeButtonOutline from '../buttons/orange-button-outline';
import { useNavigate } from 'react-router-dom';
import CustomModal from '../CustomModal';
import SignUpPopup from '../../Pages/tutor-details/components/SignupPopup';

const StudyGuideSection = () => {
  const navigate = useNavigate();
  const [showSignupModal, setShowSignupModal] = useState(false);

  return (
    <div className="mx-auto mt-12 flex flex-col-reverse items-center gap-4 md:!mt-[80px] md:gap-12 lg:flex-row">
      <div className="container w-full !max-w-[502px] space-y-4 !px-6 md:!pr-0 ">
        <div className="space-y-4">
          <h2 className="fredokaOne text-[32px]  font-normal leading-tight tracking-[-0.64px] text-[#012E33] md:text-[40px] md:tracking-[-0.8px]">
            Personalized Study Guides
          </h2>

          <p className="fredoka text-[18px] font-normal leading-[32px] tracking-[-0.18px] text-[#678285] md:text-[22px] md:tracking-[-0.22px]">
            Custom-built study guides tailored precisely to each student's academic needs, class 
            format, and personal interests.
          </p>
        </div>

        <div className="flex flex-col gap-4 md:pt-2 lg:flex-row">
          <OrangeButton
            onClick={() => setShowSignupModal(true)}
            label={'Try Generating a Personalized Study Guide'}
          />
          <OrangeButtonOutline
            onClick={() => navigate('/products/standardized-testing')}
            label={'Learn More'}
          />
        </div>
      </div>
      <div className="w-full pl-4 lg:w-1/2 lg:p-0">
        <img src="/images/home/study-guide.png" alt="Study Guide" />
      </div>
      <CustomModal
        className="max-w-[480px]"
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      >
        <SignUpPopup />
      </CustomModal>
    </div>
  );
};

export default StudyGuideSection;
